import { render, staticRenderFns } from "./classicSeven.vue?vue&type=template&id=55350ef4&"
import script from "./classicSeven.vue?vue&type=script&lang=js&"
export * from "./classicSeven.vue?vue&type=script&lang=js&"
import style0 from "./classicSeven.vue?vue&type=style&index=0&id=55350ef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports